import script from "./CoefficientsPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./CoefficientsPage.vue?vue&type=script&setup=true&lang=ts"

import "./CoefficientsPage.vue?vue&type=style&index=0&id=6f175eb6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f175eb6"]])

export default __exports__